import { useLocation } from "react-router-dom";
import googleIcon from "../assets/google-icon-real.svg";
import { API_BASE_URL } from "../../src/config";

export default function GoogleButton({ text, roleName }) {
  const location = useLocation();
  const path = location.pathname;

  const handleClick = () => {
    let role = roleName;
    window.location.href = `${API_BASE_URL}/auth/google/redirect?role=${role}`;
  };

  return (
    <button className="google-button btn-all-white" onClick={handleClick}>
      <img src={googleIcon} alt="google icon" />
      {text}
    </button>
  );
}
